import React from 'react';
export var Image = function Image(_ref) {
  var imageUrl = _ref.imageUrl,
      size = _ref.size;
  return React.createElement("image", {
    xlinkHref: imageUrl,
    href: imageUrl,
    height: size,
    width: size,
    preserveAspectRatio: "xMidYMin slice"
  });
};